<template>
  <b-navbar type="dark" variant="light" class="page-title mb-3">
    <b-navbar-nav>
      <h1 class="mb-0">
        {{ title }}
        <font-awesome-icon v-if="icon" :icon="icon"/>
        <small v-if="subtitle" class="subtitle">
          - {{ subtitle }}
        </small>
      </h1>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
export default {
  name: 'PageTitle',
  props: ['title', 'subtitle', 'icon']
}
</script>

<style lang="scss" scoped>
.page-title {
  margin-left: -15px;
  margin-right: -15px;
  padding: 1rem;
}

.subtitle {
  text-transform: none;
}

h1 {
  text-transform: uppercase;
  font-size: 1.8rem;
  line-height: 1.8rem;
  margin: 0;
  padding: 0;
}

@media (max-width: 768px) {
  h1 {
    font-size: 1.2rem;
  }
}
</style>
